<template>
  <div class="knowledgelayout">
    <el-main>
      <div class="div">
        <el-button type="primary" @click="appendTree">+&nbsp;新增</el-button>
      </div>
      <div class="div2">
        <div class="div2-br">
          <span>学段</span>
          <div class="btn">
            <el-radio-group v-model="stageId" @change="changeit">
              <el-radio-button size="small" :label="item.id"  v-for="(item,index ) in stages"  :key="index" >{{item.name}}
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="div2-br">
          <span>科目</span>
          <div class="btn">
            <el-radio-group v-model="subjectId" @change="changeSubject">
              <el-radio-button size="small" :label="item.id"  v-for="(item,index ) in subjects"  :key="index" >{{item.name}}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </div>

      <el-tree
        :data="knowledges" :props="defaultProps" v-loading="loading" @node-click="handleNodeClick" :render-content="renderContent">
      </el-tree>
      <!-- 编辑框 -->
      <edit-dialog  v-model="knowledgeDialogVisible" :rowData="rowData" :id="id" @success="editSuccess"></edit-dialog>

    </el-main>

  </div>
</template>
<script type="text/babel">
import editDialog from './edit-dialog'
import commonService from '@/service/commonService'
import knowledgeService from '@/service/knowledgeService'
export default {
  components: {
    editDialog: editDialog
  },
  data () {
    return {
      id: 0,
      nid: 10000,
      stageId: 0,
      subjectId: 0,
      stages: [],
      subjects: [],
      knowledges: [],
      rowData: {},
      knowledgeDialogVisible: false,
      tableData: [],
      defaultProps: {
        label: 'name',
        children: 'allFiledChildren'
      },
      loading: false
    }
  },
  async mounted () {
    // 查询
    await this.fetchLearnData()
    await this.fetchClassData()
    await this.fetchData()
  },
  methods: {
    async changeit () {
      await this.fetchClassData()
      await this.fetchData()
    },
    async changeSubject () {
      await this.fetchData()
    },
    /* 获取学段数据 */
    async fetchLearnData () {
      try {
        let data = await commonService.fetchCommonStage()
        if (data) {
          this.stageId = data[1].id
          this.stages = data
        } else {
          this.stages = []
          this.stageId = 0
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    /* 获取科目数据 */
    async fetchClassData () {
      try {
        let data = await commonService.fetchCommonSubject(parseInt(this.stageId))
        if (data && data.length > 0) {
          this.subjectId = data[0].id
          this.subjects = data
        } else {
          this.subjectId = 0
          this.subjects = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    async fetchData () {
      this.loading = true
      try {
        let data = await knowledgeService.fetchData(this.subjectId)
        if (data) {
          this.knowledges = data
        } else {
          this.knowledges = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
      this.loading = false
    },
    editSuccess (name) {
      this.id = 0
      this.knowledgeDialogVisible = false
      this.$set(this.rowData, 'name', name)
      this.$message.success(this.SysConstant.success)
      this.fetchData()
    },
    handleNodeClick () {
      return false
    },
    async appendTree () {
      let knowledge = {
        subjectId: this.subjectId,
        name: '新增节点',
        parentId: '0',
        type: 'TESTING_POINT'
      }
      try {
        await knowledgeService.save(knowledge)
        // 添加
        this.$message.success(this.SysConstant.success)
        this.fetchData()
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    editKnowledge (node, data) {
      this.id = data.id
      this.knowledgeDialogVisible = true
      this.rowData = data
    },
    async append (data) {
      let knowledge = {
        subjectId: this.subjectId,
        name: '新增节点',
        parentId: data.id,
        type: 'TESTING_POINT'
      }
      try {
        let resp = await knowledgeService.save(knowledge)
        // 添加
        const newChild = {
          id: resp,
          name: '新增节点',
          allFiledChildren: [],
          subjectId: this.subjectId,
          parentId: data.id,
          ordinal: resp
        }
        if (!data.allFiledChildren) {
          this.$set(data, 'allFiledChildren', [])
        }
        data.allFiledChildren.push(newChild)
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    async remove (node, data) {
      // 去掉
      const parent = node.parent
      const children = parent.data.allFiledChildren || parent.data
      const index = children.findIndex(d => d.id === data.id)
      this.$confirm('此操作将永久删除该知识点, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await knowledgeService.remove(data.id)
        this.$message.success(this.SysConstant.success)
        children.splice(index, 1)
      }).catch((e) => {
       // this.$message.error(e && e.msg)
      })
    },
    renderContent (h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span class="el-tree-node__label select-none">{node.label}</span>
          <span class="tools">
            <span class="icon-my-add icon_tool" on-click={ (e) => { node.expanded=true; this.append(data); window.event ? window.event.cancelBubble = true : e.stopPropagation() } }></span>
            <span class="icon-my-write icon_tool" on-click={ (e) => { this.editKnowledge(node, data); window.event ? window.event.cancelBubble = true : e.stopPropagation() } }></span>
            <span class="icon-my-delete icon_tool" on-click={ () => this.remove(node, data) }></span>
          </span>
        </span>)
    }
  }
}
</script>
<style scoped>
  .knowledgelayout .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  .knowledgelayout .div{
    overflow: hidden;
    height: 60px;
    background-color: white;
    margin-bottom: 5px;
  }

  .knowledgelayout .div2{
    overflow: hidden;
  }

  .knowledgelayout .div .el-button{
    background-color: #00aaff;
    color:#fff;
    height:40px;
    margin:10px;
    float:left;
  }

  .knowledgelayout .div2 .active{
    background-color: #00aaff;
    color:#fff;
  }
  .knowledgelayout .content{
    margin-top:20px;
  }
  /*每一行内容的边距*/
  .knowledgelayout .content .row{

    margin-left:50px;
  }
   /*每一行内容到标志的边距*/
  .knowledgelayout .content .row span{
    color:#fff;
    margin:20px 30px;
  }
  /*每一行的宽度*/
  .knowledgelayout .el-menu-vertical-demo{
    width:400px;
  }

  .knowledgelayout .el-col{
    margin-left:120px;
  }
  /*每个分组组内文字的边距*/
  .knowledgelayout .el-menu-item-group span{
    margin:0 20px;
  }
  .knowledgelayout .el-menu-item-group{
    margin-left:50px;
  }
 /*每一行*/
  .knowledgelayout .el-submenu{

    border-bottom:1px solid #fff;
  }
  .knowledgelayout .el-menu-item{
    border-radius: 20px;
  }
  /*整个menu*/
  .knowledgelayout .el-menu{
    margin-left:120px;
  }
  .knowledgelayout .el-main .el-tree .el-tree-node__content{
    height:50px !important;
  }
  .knowledgelayout .div2{
    overflow: hidden;
    padding:10px 0;
    margin: 0;
    background-color: #ffffff;
    color: #333;
  }

  .knowledgelayout .div2 .div2-br{
    overflow: hidden;
  }

  .knowledgelayout .div2 span{
    height:55px;
    line-height:55px;
    margin:0 40px;
    float: left;
  }
  .knowledgelayout .div2 .btn{
    width:80%;
    float: left;
  }
</style>
<style type="text/css">
  .knowledgelayout .div2 .el-radio-button{
    margin:10px 10px;
    border:none !important;
    border-radius:4px !important;
  }
  .knowledgelayout .el-radio-button__inner{

    border: 1px solid #dcdfe6;
  }

   .knowledgelayout .el-tree-node__content{
     width:720px;
     margin-top: 10px;
     height: 44px;
   }
   .knowledgelayout .el-tree{
    padding-top: 10px;
    padding-bottom: 30px;
    padding-left: 100px;
    background-color: #F3F5F8;
  }
 .knowledgelayout .el-tree-node__content:hover .el-icon-caret-right{
   background: #00AAFF;
   border-radius: 50%;
   border: solid 4px #ffffff;
 }
  .knowledgelayout .el-tree-node__content .el-icon-caret-right{
    padding:5px;
    background: #000000;
    border-radius: 50%;
    border: solid 4px #ffffff;
    margin-left: 10px;
    margin-right: 10px;
    box-shadow:0px 1px 9px 0px rgba(0, 0, 0, 0.31);
  }
 .knowledgelayout .el-tree-node__content .el-icon-caret-right:before {
   content: " ";
 }
 .knowledgelayout .el-tree-node__content:hover .el-tree-node__label{
   background-color: #00aaff;
   color: #fff;
 }
 .knowledgelayout .el-tree-node__content  .el-tree-node__label{
   height:40px;
   line-height: 40px;
   display: inline-block;
   width:600px;
   padding-left: 30px;
   color: #333333;
   background:rgba(255,255,255,1);
   box-shadow:0px 1px 9px 0px rgba(0, 0, 0, 0.17);
   border-radius:20px;
   font-size:16px;
   font-family:MicrosoftYaHei;
   font-weight:400;
  }
 .knowledgelayout .el-tree-node__children  .el-tree-node__content{
    padding-left: 60px!important;
   }
   .knowledgelayout .el-tree-node__children .el-tree-node__children  .el-tree-node__content{
     padding-left: 120px!important;
   }
   .knowledgelayout .el-tree-node__children .el-tree-node__children .el-tree-node__children  .el-tree-node__content{
     padding-left: 180px!important;
   }
   .knowledgelayout .el-tree-node__children .el-tree-node__children
   .el-tree-node__children .el-tree-node__children .el-tree-node__content{
     padding-left: 240px!important;
   }
   .knowledgelayout
   .el-tree-node__children
   .el-tree-node__children
   .el-tree-node__children
   .el-tree-node__children
   .el-tree-node__children .el-tree-node__content{
     padding-left: 300px!important;
   }
   .knowledgelayout
   .el-tree-node__children
   .el-tree-node__children
   .el-tree-node__children
   .el-tree-node__children
   .el-tree-node__children
   .el-tree-node__children .el-tree-node__content{
     padding-left: 360px!important;
   }
   .knowledgelayout  .custom-tree-node .tools{
     height: 40px;
     width: 110px;
     line-height: 40px;
     display: none;
   }
   .knowledgelayout  .el-tree-node__content:hover .custom-tree-node .tools{
     display: inline-block;
     z-index: 99999;
   }
   .knowledgelayout  .custom-tree-node .tools  .icon_tool{
     height: 20px;
     width: 20px;
     vertical-align: middle;
     line-height: 20px;
     display: inline-block;
     margin-left: 15px;
   }
</style>



// WEBPACK FOOTER //
// src/pages/layout/knowledge-manage/index.vue